import { MenuItem, Select, Stack, Typography } from '@mui/material';
import { AccountState, type Account } from '@repo/api-gw-sdk';

import { FormTextField } from '@/components/form/formTextField';

import type { IntegrationWizardState } from '../integrationWizardFlow';

interface BigQueryConfigurationProps {
  wizardState: IntegrationWizardState;
  setWizardState: (
    updater: (state: IntegrationWizardState) => IntegrationWizardState
  ) => void;
  restoreAccountsResponse?: { accounts: Account[] };
}

export const BigQueryConfiguration = ({
  wizardState,
  setWizardState,
  restoreAccountsResponse,
}: BigQueryConfigurationProps) => {
  return (
    <>
      <Stack className='w-[582px]' gap='8px'>
        <Typography>Restore account</Typography>
        <Select
          value={wizardState.config?.bigquery?.projectId || ''}
          displayEmpty
          disabled={!restoreAccountsResponse}
          onChange={(event) =>
            setWizardState((state) => ({
              ...state,
              config: {
                ...state.config,
                bigquery: {
                  projectId: event.target.value,
                  dataset: state.config?.bigquery?.dataset || '',
                },
              },
            }))
          }
          renderValue={(value) =>
            value
              ? restoreAccountsResponse?.accounts.find(
                  (a: Account) => a.providerAccountId === value
                )?.name || value
              : 'Select a restore account'
          }
        >
          {(restoreAccountsResponse?.accounts || [])
            .filter(
              (account: Account) =>
                account.state === AccountState.ACCOUNT_STATE_CONNECTED
            )
            .map((account: Account) => (
              <MenuItem key={account.id} value={account.providerAccountId}>
                {account.name} ({account.providerAccountId})
              </MenuItem>
            ))}
        </Select>
      </Stack>
      <FormTextField
        title='Dataset'
        placeholder='Example: analytics_warehouse'
        value={wizardState.config?.bigquery?.dataset || ''}
        onChange={(event) =>
          setWizardState((state) => ({
            ...state,
            config: {
              ...state.config,
              bigquery: {
                projectId: state.config?.bigquery?.projectId || '',
                dataset: event.target.value,
              },
            },
          }))
        }
      />
    </>
  );
};
